
// // // src/pages/EmployeeDetailsModal.jsx
// // import React from "react";
// // import "../styles/theme.css"

// // const EmployeeDetailsModal = ({ show, onClose, employee }) => {
// //     if (!show || !employee) return null;

// //     const name = `${employee.firstName || ""} ${employee.lastName || ""}`.trim();

// //     return (
// //         <div className="modal d-block" role="dialog" aria-modal="true">
// //             <div className="modal-dialog modal-lg modal-dialog-centered">
// //                 <div className="modal-content shadow">
// //                     <div className="modal-header primary-bg">
// //                         <h5 className="modal-title">Employee Details — {name || "Unnamed"}</h5>
// //                         <button className="btn-close text-light " onClick={onClose} aria-label="Close" />
// //                     </div>
// //                     <div className="modal-body">
// //                         <div className="row g-3">
// //                             <div className="col-12 col-md-6"><strong>Employee ID:</strong> {employee.empId || "-"}</div>
// //                             {/* <div className="col-12 col-md-6 text-capitalize"><strong>Status:</strong> {employee.status || "-"}</div> */}

// //                             <div className="col-12 col-md-6 text-capitalize">
// //                                 <strong>Status:</strong>{" "}
// //                                 <span className={employee?.status?.toLowerCase() === "approved" ? "text-success" : "text-danger"}>
// //                                     {employee?.status || "-"}
// //                                 </span>
// //                             </div>

// //                             <div className="col-12 col-md-6 text-capitalize"><strong>Role:</strong> {employee.role || "-"}</div>
// //                             <div className="col-12 col-md-6 text-capitalize"><strong>First Name:</strong> {employee.firstName || "-"}</div>
// //                             <div className="col-12 col-md-6 text-capitalize"><strong>Surname:</strong> {employee.lastName || "-"}</div>
// //                             <div className="col-12 col-md-6 text-capitalize"><strong>Father Name:</strong> {employee.fatherName || "-"}</div>
// //                             <div className="col-12 text-capitalize"><strong>Address:</strong> {employee.address || "-"}</div>
// //                             <div className="col-12 col-md-6"><strong>Mobile:</strong> {employee.mobile || "-"}</div>
// //                             <div className="col-12 col-md-6"><strong>Email:</strong> {employee.email || "-"}</div>
// //                             <div className="col-12 col-md-6"><strong>Aadhaar:</strong> {employee.aadhaar || "-"}</div>
// //                             <div className="col-12 col-md-6"><strong>PAN:</strong> {employee.pan || "-"}</div>

// //                             <div className="col-12 text-capitalize">
// //                                 <strong>Authorized IDs:</strong>
// //                                 <ul className="mb-0">
// //                                     {(employee.ids || []).map((r, i) => (
// //                                         <li key={i}>{r.type}: {r.value}</li>
// //                                     ))}
// //                                     {(employee.ids || []).length === 0 && <li>—</li>}
// //                                 </ul>
// //                             </div>

// //                             <div className="col-12 col-md-6"><strong>Category:</strong> {employee.categoryKey || "-"}</div>
// //                             <div className="col-12 col-md-6"><strong>Subcategory:</strong> {employee.subcategoryKey || "-"}</div>

// //                             <div className="col-12 col-md-6"><strong>UID (Auth):</strong> {employee.uid || "-"}</div>
// //                         </div>
// //                     </div>
// //                     <div className="modal-footer">
// //                         <button className="btn btn-outline-secondary" type="button" onClick={onClose}>
// //                             Close
// //                         </button>
// //                     </div>
// //                 </div>
// //             </div>
// //             <div onClick={onClose} />
// //         </div>
// //     );
// // };

// // export default EmployeeDetailsModal;


// import React from "react";

// /**
//  * Props:
//  *  - show: boolean
//  *  - onClose: () => void
//  *  - employee: Firestore doc { ... , ids: [{type, value, imageUrl}], profilePhotoUrl }
//  */
// export default function EmployeeDetailsModal({ show, onClose, employee }) {
//     if (!show || !employee) return null;

//     const {
//         empId,
//         status,
//         role,
//         firstName,
//         lastName,
//         fatherName,
//         address,
//         mobile,
//         email,
//         aadhaar,
//         pan,
//         categoryKey,
//         subcategoryKey,
//         uid,
//         profilePhotoUrl,
//         ids = [],
//         ageYears,
//         experienceYears,
//         jobs = [],
//     } = employee;

//     const mask = (v = "") => (v ? String(v).replace(/(?<=.{3}).(?=.{2})/g, "•") : "-");

//     return (
//         <div className="modal d-block" tabIndex="-1" role="dialog" aria-modal="true">
//             <div className="modal-dialog modal-xl">
//                 <div className="modal-content">
//                     <div className="modal-header">
//                         <div>
//                             <h5 className="modal-title mb-0">
//                                 Employee ID: {empId} &nbsp;•&nbsp; <span className="badge bg-secondary">{status}</span>
//                             </h5>
//                             <small className="text-muted">Role: {role || "employee"}</small>
//                         </div>
//                         <button className="btn-close" aria-label="Close" onClick={onClose} />
//                     </div>

//                     <div className="modal-body">
//                         <div className="row g-3">
//                             {/* Left: Profile & IDs */}
//                             <div className="col-12 col-lg-4">
//                                 {/* Profile photo */}
//                                 <div className="card shadow-sm mb-3">
//                                     <div className="card-header py-2"><strong>Profile Photo</strong></div>
//                                     <div className="card-body text-center">
//                                         {profilePhotoUrl ? (
//                                             <a href={profilePhotoUrl} target="_blank" rel="noreferrer">
//                                                 <img
//                                                     src={profilePhotoUrl}
//                                                     alt="Profile"
//                                                     className="img-fluid rounded"
//                                                     style={{ maxHeight: 220, objectFit: "cover" }}
//                                                 />
//                                             </a>
//                                         ) : (
//                                             <div className="text-muted">No profile photo</div>
//                                         )}
//                                     </div>
//                                 </div>

//                                 {/* Authorized ID images */}
//                                 <div className="card shadow-sm">
//                                     <div className="card-header py-2"><strong>Authorized IDs</strong></div>
//                                     <div className="card-body">
//                                         {ids.length === 0 && <div className="text-muted">No IDs attached</div>}

//                                         <div className="row g-2">
//                                             {ids.map((r, i) => (
//                                                 <div className="col-12" key={i}>
//                                                     <div className="d-flex gap-2 align-items-start border rounded p-2">
//                                                         <div style={{ width: 96 }}>
//                                                             {r?.imageUrl ? (
//                                                                 <a href={r.imageUrl} target="_blank" rel="noreferrer">
//                                                                     <img
//                                                                         src={r.imageUrl}
//                                                                         alt={`${r.type || "ID"} image`}
//                                                                         className="img-thumbnail"
//                                                                         style={{ width: 96, height: 72, objectFit: "cover" }}
//                                                                     />
//                                                                 </a>
//                                                             ) : (
//                                                                 <div
//                                                                     className="bg-light d-flex align-items-center justify-content-center"
//                                                                     style={{ width: 96, height: 72 }}
//                                                                 >
//                                                                     <span className="text-muted small">No image</span>
//                                                                 </div>
//                                                             )}
//                                                         </div>
//                                                         <div className="flex-grow-1">
//                                                             <div className="fw-semibold">{r?.type || "ID"}</div>
//                                                             <div className="text-muted small">{mask(r?.value)}</div>
//                                                             {r?.imageUrl && (
//                                                                 <div className="small mt-1">
//                                                                     <a href={r.imageUrl} target="_blank" rel="noreferrer">
//                                                                         Open full image
//                                                                     </a>
//                                                                 </div>
//                                                             )}
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             ))}
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Right: Details */}
//                             <div className="col-12 col-lg-8">
//                                 <div className="card shadow-sm mb-3">
//                                     <div className="card-header py-2"><strong>Basic Info</strong></div>
//                                     <div className="card-body">
//                                         <div className="row">
//                                             <div className="col-6"><small className="text-muted">First Name</small><div>{firstName || "-"}</div></div>
//                                             <div className="col-6"><small className="text-muted">Surname</small><div>{lastName || "-"}</div></div>
//                                             <div className="col-6 mt-2"><small className="text-muted">Father Name</small><div>{fatherName || "-"}</div></div>
//                                             <div className="col-6 mt-2"><small className="text-muted">Age (years)</small><div>{ageYears ?? "-"}</div></div>
//                                             <div className="col-6 mt-2"><small className="text-muted">Experience (years)</small><div>{experienceYears ?? "-"}</div></div>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="card shadow-sm mb-3">
//                                     <div className="card-header py-2"><strong>Contact</strong></div>
//                                     <div className="card-body">
//                                         <div className="row">
//                                             <div className="col-6"><small className="text-muted">Mobile</small><div>{mobile || "-"}</div></div>
//                                             <div className="col-6"><small className="text-muted">Email</small><div>{email || "-"}</div></div>
//                                             <div className="col-6 mt-2"><small className="text-muted">Aadhaar</small><div>{mask(aadhaar)}</div></div>
//                                             <div className="col-6 mt-2"><small className="text-muted">PAN</small><div>{mask(pan)}</div></div>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="card shadow-sm mb-3">
//                                     <div className="card-header py-2"><strong>Address</strong></div>
//                                     <div className="card-body">{address || "-"}</div>
//                                 </div>

//                                 <div className="card shadow-sm">
//                                     <div className="card-header py-2"><strong>Primary Role</strong></div>
//                                     <div className="card-body">
//                                         <div className="row">
//                                             <div className="col-6"><small className="text-muted">Category</small><div>{categoryKey || "-"}</div></div>
//                                             <div className="col-6"><small className="text-muted">Subcategory</small><div>{subcategoryKey || "-"}</div></div>
//                                             <div className="col-12 mt-2">
//                                                 <small className="text-muted d-block">All Jobs</small>
//                                                 {jobs?.length ? (
//                                                     <ul className="mb-0">
//                                                         {jobs.map((j, idx) => (
//                                                             <li key={idx}>
//                                                                 {j.title || "-"} {j.experienceYears != null ? `• ${j.experienceYears}y` : ""}{" "}
//                                                                 {j.categoryKey ? `• ${j.categoryKey}` : ""} {j.subcategoryKey ? `/${j.subcategoryKey}` : ""}
//                                                             </li>
//                                                         ))}
//                                                     </ul>
//                                                 ) : (
//                                                     <div className="text-muted">No jobs provided</div>
//                                                 )}
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="mt-3">
//                                     <small className="text-muted">UID (Auth)</small>
//                                     <div className="small">{uid || "-"}</div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="modal-footer">
//                         <button className="btn btn-secondary" onClick={onClose}>Close</button>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }




import React from "react";

export default function EmployeeDetailsModal({ show, onClose, employee }) {
    if (!show || !employee) return null;

    const {
        empId, status, role, firstName, lastName, fatherName, address,
        mobile, email, aadhaar, pan, categoryKey, subcategoryKey, uid,
        profilePhotoUrl, ids = [], ageYears, experienceYears, jobs = [],
    } = employee;

    const mask = (v = "") => (v ? String(v).replace(/(?<=.{3}).(?=.{2})/g, "•") : "-");

    return (
        <div className="modal d-block" tabIndex="-1" role="dialog" aria-modal="true">
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <div>
                            <h5 className="modal-title mb-0">
                                Employee ID: {empId} &nbsp;•&nbsp; <span className="badge bg-secondary">{status}</span>
                            </h5>
                            <small className="text-muted">Role: {role || ""}</small>
                        </div>
                        <button className="btn-close" aria-label="Close" onClick={onClose} />
                    </div>

                    <div className="modal-body">
                        <div className="row g-3">
                            {/* Left: Profile & IDs */}
                            <div className="col-12 col-lg-4">
                                <div className="card shadow-sm mb-3">
                                    <div className="card-header py-2"><strong>Profile Photo</strong></div>
                                    <div className="card-body text-center">
                                        {profilePhotoUrl ? (
                                            <a href={profilePhotoUrl} target="_blank" rel="noreferrer">
                                                <img src={profilePhotoUrl} alt="Profile" className="img-fluid rounded" style={{ maxHeight: 220, objectFit: "cover" }} />
                                            </a>
                                        ) : (
                                            <div className="text-muted">No profile photo</div>
                                        )}
                                    </div>
                                </div>

                                <div className="card shadow-sm">
                                    <div className="card-header py-2"><strong>Authorized IDs</strong></div>
                                    <div className="card-body">
                                        {ids.length === 0 && <div className="text-muted">No IDs attached</div>}
                                        <div className="row g-2">
                                            {ids.map((r, i) => (
                                                <div className="col-12" key={i}>
                                                    <div className="d-flex gap-2 align-items-start border rounded p-2">
                                                        <div style={{ width: 96 }}>
                                                            {r?.imageUrl ? (
                                                                <a href={r.imageUrl} target="_blank" rel="noreferrer">
                                                                    <img
                                                                        src={r.imageUrl}
                                                                        alt={`${r.type || "ID"} image`}
                                                                        className="img-thumbnail"
                                                                        style={{ width: 96, height: 72, objectFit: "cover" }}
                                                                    />
                                                                </a>
                                                            ) : (
                                                                <div className="bg-light d-flex align-items-center justify-content-center"
                                                                    style={{ width: 96, height: 72 }}>
                                                                    <span className="text-muted small">No image</span>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="flex-grow-1">
                                                            <div className="fw-semibold">{r?.type || "ID"}</div>
                                                            <div className="text-muted small">{mask(r?.value)}</div>
                                                            {r?.imageUrl && (
                                                                <div className="small mt-1">
                                                                    <a href={r.imageUrl} target="_blank" rel="noreferrer">Open full image</a>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Right: Details */}
                            <div className="col-12 col-lg-8">
                                <div className="card shadow-sm mb-3">
                                    <div className="card-header py-2"><strong>Basic Info</strong></div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-6"><small className="text-muted">First Name</small><div>{firstName || "-"}</div></div>
                                            <div className="col-6"><small className="text-muted">Surname</small><div>{lastName || "-"}</div></div>
                                            <div className="col-6 mt-2"><small className="text-muted">Father Name</small><div>{fatherName || "-"}</div></div>
                                            <div className="col-6 mt-2"><small className="text-muted">Age (years)</small><div>{ageYears ?? "-"}</div></div>
                                            <div className="col-6 mt-2"><small className="text-muted">Experience (years)</small><div>{experienceYears ?? "-"}</div></div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card shadow-sm mb-3">
                                    <div className="card-header py-2"><strong>Contact</strong></div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-6"><small className="text-muted">Mobile</small><div>{mobile || "-"}</div></div>
                                            <div className="col-6"><small className="text-muted">Email</small><div>{email || "-"}</div></div>
                                            <div className="col-6 mt-2"><small className="text-muted">Aadhaar</small><div>{mask(aadhaar)}</div></div>
                                            <div className="col-6 mt-2"><small className="text-muted">PAN</small><div>{mask(pan)}</div></div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card shadow-sm mb-3">
                                    <div className="card-header py-2"><strong>Address</strong></div>
                                    <div className="card-body">{address || "-"}</div>
                                </div>

                                <div className="card shadow-sm">
                                    <div className="card-header py-2"><strong>Primary & Jobs</strong></div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-6"><small className="text-muted">Category</small><div>{categoryKey || "-"}</div></div>
                                            <div className="col-6"><small className="text-muted">Subcategory</small><div>{subcategoryKey || "-"}</div></div>
                                            <div className="col-12 mt-2">
                                                <small className="text-muted d-block">All Jobs</small>
                                                {jobs?.length ? (
                                                    <ul className="mb-0">
                                                        {jobs.map((j, idx) => (
                                                            <li key={idx}>
                                                                {j.title || "-"} {j.experienceYears != null ? `• ${j.experienceYears}y` : ""}{" "}
                                                                {j.categoryKey ? `• ${j.categoryKey}` : ""} {j.subcategoryKey ? `/${j.subcategoryKey}` : ""}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                ) : (
                                                    <div className="text-muted">No jobs provided</div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-3">
                                    <small className="text-muted">UID (Auth)</small>
                                    <div className="small">{uid || "-"}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button className="btn btn-secondary" onClick={onClose}>Close</button>
                    </div>
                </div>
            </div>
        </div>
    );
}
